import { create } from 'zustand';

type RoleBaseFields = {
  name: string;
  description: string;
};

type CredentialBaseFields = {
  role: string;
  roleId: string | null;
  roleDescription: string | null;
  headers: Array<{ key: string; value: string }>;
  cookies: Array<{ name: string; value: string }>;
};

type ApplicationCopilotEditContextStore = {
  roleBaseFieldsById: Record<string, RoleBaseFields>;
  credentialBaseFieldsById: Record<string, CredentialBaseFields>;
  setRoleCatalog: (
    roles: Array<{
      id: string;
      name: string;
      description: string | null;
    }>,
  ) => void;
  setCredentialCatalog: (
    credentials: Array<{
      id: string;
      role: string;
      roleId: string | null;
      roleDescription: string | null;
      headers: Array<{ key: string; value: string }>;
      cookies: Array<{ name: string; value: string }>;
    }>,
  ) => void;
  getRoleBaseFields: (roleId: string) => RoleBaseFields | undefined;
  getCredentialBaseFields: (
    credentialId: string,
  ) => CredentialBaseFields | undefined;
  clearCatalog: () => void;
};

export const useApplicationCopilotEditContextStore =
  create<ApplicationCopilotEditContextStore>((set, get) => ({
    roleBaseFieldsById: {},
    credentialBaseFieldsById: {},

    setRoleCatalog: (roles) => {
      set({
        roleBaseFieldsById: Object.fromEntries(
          roles.map((role) => [
            role.id,
            {
              name: role.name,
              description: role.description ?? '',
            },
          ]),
        ),
      });
    },

    setCredentialCatalog: (credentials) => {
      set({
        credentialBaseFieldsById: Object.fromEntries(
          credentials.map((credential) => [
            credential.id,
            {
              role: credential.role,
              roleId: credential.roleId,
              roleDescription: credential.roleDescription,
              headers: credential.headers,
              cookies: credential.cookies,
            },
          ]),
        ),
      });
    },

    getRoleBaseFields: (roleId) => get().roleBaseFieldsById[roleId],

    getCredentialBaseFields: (credentialId) =>
      get().credentialBaseFieldsById[credentialId],

    clearCatalog: () => {
      set({
        roleBaseFieldsById: {},
        credentialBaseFieldsById: {},
      });
    },
  }));
